// extracted by mini-css-extract-plugin
export default {"dockedFloatingButton":"dockedfloatingbutton_dockedFloatingButton__zVi0g"};